export default __webpack_public_path__ + "static/media/FRONT FORK STEM + HANDLE STOPPER_PRESSING_MACHINE.1187d687.png";